// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__14oM8","col":"Table_col__-IDaf","fulfillmentStatus":"Table_fulfillmentStatus__HDkov","emailCol":"Table_emailCol__1-i8H"};